var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isUnfairList
    ? _c(
        "div",
        { staticClass: "unfair" },
        [
          !_vm.isAllArchived
            ? _c("span", [
                _c("span", { staticClass: "unfair__msg" }, [
                  _vm._v(
                    "C " +
                      _vm._s(_vm.dateParser(_vm.firstActual.unfair_date)) +
                      " включён в реестр недобросовестных поставщиков."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "uk-pseudolink no-print",
                    on: { click: _vm.modalHandler },
                  },
                  [_vm._v("Предыдущие включения")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isAllArchived
            ? _c("span", [
                _c("span", { staticClass: "unfair__msg" }, [
                  _vm._v("Ранее был включён в "),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "uk-pseudolink no-print",
                    on: { click: _vm.modalHandler },
                  },
                  [_vm._v("реестр недобросовестных поставщиков. ")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "unfair__msg" }, [
                  _vm._v("На данный момент исключён из реестра."),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isModal
            ? _c("unfair-modal", {
                attrs: {
                  actualList: _vm.actualList,
                  archiveList: _vm.archiveList,
                  close: _vm.modalHandler,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }